<template>
	<main class="feedback">
		<h6>고객소리함</h6>
		<form @submit.prevent="onSubmit">
			<FieldLayout title="제목" :error="errors.member_id">
				<InputText v-model="title" maxlength="30" :placeholder="PLACEHOLDER_TITLE_30" @input="onChangeLength" />
			</FieldLayout>
			<FieldLayout title="내용" :error="errors.member_id">
				<TextareaCounter v-model="content" maxlength="1000" :placeholder="INPUT_CONTENTS" />
			</FieldLayout>
			<div class="button_box">
				<button class="c_button primary-fill radius-x-small" :disabled="!title || !content">완료</button>
			</div>
		</form>
	</main>
</template>

<script setup lang="ts">
// validation
import { useForm } from 'vee-validate';
import * as yup from 'yup';

// api
import { useSaveVoiceApi } from '@/api/feedback';
// component
import InputText from '@/components/atom/input/InputText.vue';
import TextareaCounter from '@/components/atom/textarea/TextareaCounter.vue';
import FieldLayout from '@/components/form/FieldLayout.vue';
// constant
import {
	COMPANY_TITLE,
	ERROR_REQUIRED_FIELD,
	INPUT_CONTENTS,
	MESSAGE_POST_COMPLETED,
	PLACEHOLDER_TITLE_30,
} from '@/constants/title';
import router from '@/router';
// store
import { useToastStore } from '@/stores/toast';

// -----variable-----
const toastStore = useToastStore();

// -----validation-----
const { errors, defineField } = useForm({
	validationSchema: yup.object({
		title: yup.string().required(ERROR_REQUIRED_FIELD),

		content: yup.string().required(ERROR_REQUIRED_FIELD),
	}),
});
const [title] = defineField('title'); //고객소리함 제목
const [content] = defineField('content'); // 고객소리함 내용

// -----api-----
const { mutateAsync: saveVoice } = useSaveVoiceApi();

// -----function-----
const onSubmit = async () => {
	const formData = new FormData();
	formData.append('voice_title', title.value);
	formData.append('voice_open_yn', '1');
	formData.append('voice_content', content.value);
	const res = await saveVoice(formData);
	if (res.data.success) {
		toastStore.openToast({
			subContent: COMPANY_TITLE,
			content: MESSAGE_POST_COMPLETED,
		});
		router.replace('/');
	}
};
const onChangeLength = (e: Event) => {
	const MAX_LENGTH = 30;
	const target = (e.target as HTMLInputElement).value;
	if (target.length > MAX_LENGTH) {
		title.value = target.substring(0, MAX_LENGTH);
		(e.target as HTMLInputElement).value = target.substring(0, MAX_LENGTH);
	}
};
</script>

<style lang="scss" scoped>
.feedback {
	display: flex;
	flex-direction: column;
	padding-top: var(--header-height);
	max-width: 40rem;
	margin: 0 auto;
	margin-top: var(--space-xxxxxxxx-large);
	margin-bottom: 22.8rem;
	width: 100%;
	gap: 4rem;
	@media screen and (max-width: 1280px) {
		padding: 4rem 2rem 0rem 2rem;
	}
	form {
		display: flex;
		flex-direction: column;
		justify-content: center;
		gap: 3.2rem;
		font-weight: var(--font-w-medium);
		font-size: var(--font-s-mid);
		color: var(--color-font-white);
		line-height: 1.79rem;
		.c_input {
			background-color: var(--color-bg);
			border-color: var(--color-base-mid);
			border-radius: var(--border-radius-x-small);
		}
		.c_textarea {
			background-color: var(--color-bg);
			border-color: var(--color-base-mid);
		}
		.button_box {
			display: flex;
			gap: 1rem;
			justify-content: center;
			button {
				flex: 1;
				height: 4.8rem;
			}
		}
	}
}
</style>
